// biome-ignore lint/style/noEnum: Preserve the established enum values and runtime API used by existing callers
export enum UrlParameterKeys {
    ASSET_IDS = 'assetIds',
    RESOURCE_IDS = 'resourceIds',
    PRODUCT_ID = 'productId',
    POPUP = 'popup',
    LEVEL = 'level',
    LOCKED = 'locked',
    INTERNAL_CAMPAIGN = 'internalCampaign',
}
